import { BaseController } from './BaseController';
import { post } from '../Utils/helpers';

export default class QuizAnswerController extends BaseController {
    id = 'QuizAnswerController';

    init() {
        this.root = this.getRoot();
        this.nrOfQuestions = this.getData(this.root, 'quizNrQuestions');
        this.quizId = this.getData(this.root, 'quizId');
        let btnAnswers = document.getElementsByClassName('btn-answer');
        this.answeredTotal = {};
        this.csrfToken = this.getData(this.root, 'csrftoken');
        this.quizResultsWindow = this.singleChildNode('quiz-results');
        this.finishRequest = '';
        this.isFinished = false;

        for (var i = 0; i < btnAnswers.length; i++) {
            btnAnswers[i].addEventListener('click', this.handleAnswerClick);
        }
    }

    callbackPost = (data) => {
        if (this.finishRequest.readyState === XMLHttpRequest.DONE) {
            if (this.finishRequest.status === 0 || (this.finishRequest.status >= 200 && this.finishRequest.status < 400)) {
                this.quizResultsWindow.innerHTML = data.target.response;
            
                this.quizResultsWindow.classList.remove('d-none');
            }
        }  
    };

    handleFinish = () => {
        this.isFinished = true;
        this.root.classList.add('no-click');
        this.finishRequest = post('/quiz/results/', this.callbackPost, {'Content-Type': 'application/json; charset=UTF-8', 'X-CSRFToken': this.csrfToken}, JSON.stringify({'quiz_id': this.quizId, 'lang': document.body.lang}));
    };

    checkHasAnsweredAll = (qid, oid, target) => {
        var question = target.closest('.question');
        var qOptions = question.querySelectorAll('.question-option');
        
        for (var i = 0; i < qOptions.length; i++) {
            qOptions[i].classList.remove('is-selected');
        }

        target.classList.add('is-selected');
        this.answeredTotal[qid] = oid;

        if (Object.keys(this.answeredTotal).length == this.nrOfQuestions) {
            this.handleFinish();
        }
    };

    handleAnswerClick = (e) => {
        if (!this.isFinished) {
            this.checkHasAnsweredAll(this.getData(e.currentTarget, 'questionId'), this.getData(e.currentTarget, 'optionId'), e.currentTarget);

            post('/quiz/response/', () => {}, {'Content-Type': 'application/json; charset=UTF-8', 'X-CSRFToken': this.csrfToken}, JSON.stringify({'qid': this.getData(e.currentTarget, 'questionId'), 'oid': this.getData(e.currentTarget, 'optionId'), 'quiz_id': this.quizId}));
        }
    };
}
